// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"65d89cac","171":"308aba18","429":"cc21e1a5","751":"30a11148"}[chunkId] + ".chunk.js";
};